import { request } from "../request";
const mock = "";
// const mock = "https://yapi.upho2015.com/mock/530";
// 获取组织信息
export const getOrganizationInfo = (params) =>
  request(`${mock}/v1/organization/invite/get`, "get", { params });
// 加入组织
export const joinOrganization = (params) =>
  request(`${mock}/v1/organization/join`, "post", { json: params });
// 机构基本信息
export const getOrganization = (params) =>
  request(`${mock}/v1/organization/get`, "get", { params });
//
export const getOrganizationHome = (params) =>
  request(`${mock}/v1/organization/homePage/get`, "get", { params });
// 获取教师主页信息
export const getTeacherHomePage = (params) =>
  request(`${mock}/v1/organization/teacherHomePage/get`, "get", { params });
// 创建用户咨询
export const consultationApplication = (params) =>
  request(`${mock}/v1/organization/consultationApplication/create`, "post", {
    json: params,
  });
// 获取机构信息列表
export const getOrganizationList = (params) =>
  request(`${mock}/v1/organization/getList`, "get", { params });
